import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../services/api';

// Defaults — all ON except donate, so the app works even if /api/config fails
const DEFAULTS = {
  market:       true,
  portfolio:    true,
  contests:     true,
  friends:      true,
  feed:         true,
  intelligence: true,
  leaderboard:  true,
  donate:       false,
  profile:      true,
};

const FeatureContext = createContext(DEFAULTS);

export function FeatureProvider({ children }) {
  const [features, setFeatures] = useState(DEFAULTS);

  useEffect(() => {
    API.get('/config')
      .then(r => setFeatures({ ...DEFAULTS, ...r.data.features }))
      .catch(() => {}); // keep defaults if request fails
  }, []);

  return (
    <FeatureContext.Provider value={features}>
      {children}
    </FeatureContext.Provider>
  );
}

export const useFeatures = () => useContext(FeatureContext);
